import { requestJson } from "./instateamEmployeeApi";

export function getEmployeePerformanceOverview(token, params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) searchParams.set(key, value);
  });

  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";

  return requestJson(`/instateam/performance/employee/overview${suffix}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
